import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import ValuePillars from './components/ValuePillars';
import SocialProof from './components/SocialProof';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-white">
      <Header />
      <Hero scrollY={scrollY} />
      <ProblemSolution />
      <ValuePillars />
      <SocialProof />
      <FinalCTA />
    </div>
  );
}
